<template>
  <div>
    <div class="px-4 pb-3">
      <v-btn style="float: right" @click="$emit('close')" icon>
        <v-icon>close</v-icon>
      </v-btn>

      <div style="font-size: 20px; font-weight: 600" class="pt-3 mb-3">
        {{ edittype == 'create' ? 'เพิ่ม' : 'แก้ไข' }}ข้อมูล Reward
      </div>
      <div class="form-control">
        <v-layout class="pa-0 ma-0" wrap row>
          <v-flex xs12 sm4 class="py-2">
            <uploadfile :height="200" v-model="input.photo"></uploadfile>
            <div>
              <v-checkbox v-model="input.ecoupon_status" label="E-Coupon"></v-checkbox>
            </div>
          </v-flex>
          <v-flex xs12 sm8 class="pl-2">
            <div class="caption">ชื่อรางวัล</div>
            <div class="form-control pa-1" :class="{ 'has-error': errors.has('name') }">
              <input
                placeholder="ชื่อรางวัล"
                :data-vv-as="$t('ชื่อรางวัล')"
                v-validate="'required'"
                v-model="input.name"
                class="form-control"
                type="text"
                name="name"
              />
              <span class="text-error" v-if="errors.has('name')">{{ errors.first('name') }}</span>
            </div>
            <div class="caption">ข้อมูลรางวัล</div>
            <div class="form-control pa-1" :class="{ 'has-error': errors.has('detail') }">
              <input
                placeholder="ข้อมูลรางวัล"
                :data-vv-as="$t('ข้อมูลรางวัล')"
                v-validate="'required'"
                v-model="input.description"
                class="form-control"
                type="text"
                name="detail"
              />
              <span class="text-error" v-if="errors.has('detail')">{{
                errors.first('detail')
              }}</span>
            </div>
            <div class="caption">Category</div>
            <div class="form-control pa-1" :class="{ 'has-error': errors.has('Category') }">
              <Multiselect
                :allow-empty="false"
                :show-labels="false"
                :options="categories"
                placeholder=""
                v-validate="'required'"
                v-model="input.category"
                label="name"
                track-by="id"
                name="Category"
              >
              </Multiselect>

              <span class="text-error" v-if="errors.has('Category')">{{
                errors.first('Category')
              }}</span>
            </div>
            <div class="caption">รหัสสินค้า</div>
            <div class="form-control pa-1" :class="{ 'has-error': errors.has('รหัสสินค้า') }">
              <input
                placeholder="รหัสสินค้า"
                :data-vv-as="$t('รหัสสินค้า')"
                v-validate="'required'"
                v-model="input.sku"
                class="form-control"
                type="text"
                name="รหัสสินค้า"
              />
              <span class="text-error" v-if="errors.has('รหัสสินค้า')">{{
                errors.first('รหัสสินค้า')
              }}</span>
            </div>
            <template v-if="selectedCampaign && selectedCampaign.type != 'lucky_draw'">
              <div class="caption">แต้มที่ใช้</div>
              <div class="form-control pa-1" :class="{ 'has-error': errors.has('แต้มที่ใช้') }">
                <input
                  placeholder="แต้มที่ใช้"
                  :data-vv-as="$t('แต้มที่ใช้')"
                  v-validate="'required'"
                  v-model="input.points"
                  class="form-control"
                  type="text"
                  name="แต้มที่ใช้"
                  @keypress="keyIsNumber"
                />
                <span class="text-error" v-if="errors.has('แต้มที่ใช้')">{{
                  errors.first('แต้มที่ใช้')
                }}</span>
              </div>
            </template>
            <div class="caption">มูลค่าของรางวัล</div>
            <div class="form-control pa-1" :class="{ 'has-error': errors.has('มูลค่าของรางวัล') }">
              <input
                placeholder="มูลค่าของรางวัล"
                :data-vv-as="$t('มูลค่าของรางวัล')"
                v-validate="'required'"
                v-model="input.price"
                class="form-control"
                type="text"
                @keypress="keyIsNumber"
                name="มูลค่าของรางวัล"
              />
              <span class="text-error" v-if="errors.has('มูลค่าของรางวัล')">{{
                errors.first('มูลค่าของรางวัล')
              }}</span>
            </div>
            <div class="caption">แคมเปญ</div>
            <div class="form-control pa-1" :class="{ 'has-error': errors.has('campaign') }">
              <input
                readonly
                placeholder="แคมเปญ"
                v-model="campaignName"
                class="form-control"
                type="text"
                name="campaign"
              />
              <span class="text-error" v-if="errors.has('name')">{{
                errors.first('campaign')
              }}</span>
            </div>
          </v-flex>
        </v-layout>
      </div>
    </div>
    <v-divider></v-divider>
    <div class="px-3 pt-3">
      <div style="font-weight: bold">จำนวนในการแลกของรางวัล</div>
      <div>
        <v-layout row wrap class="ma-0 pa-0">
          <v-flex xs6 v-if="selectedCampaign && selectedCampaign.type != 'lucky_draw'">
            <v-switch v-model="input.one_time" label="1 คน / 1 ครั้ง"></v-switch
          ></v-flex>
          <v-flex xs6>
            <div>จำนวน Reward</div>
            <div class="form-control pa-1" :class="{ 'has-error': errors.has('จำนวน Reward') }">
              <input
                placeholder="จำนวน Reward"
                :data-vv-as="$t('จำนวน Reward')"
                v-validate="'required'"
                v-model="input.quantity"
                class="form-control"
                type="text"
                @keypress="keyIsNumber"
                name="จำนวน Reward"
              />
              <span class="text-error" v-if="errors.has('จำนวน Reward')">{{
                errors.first('จำนวน Reward')
              }}</span>
            </div>
          </v-flex>
          <v-flex style="font-weight: bold" xs12> ระยะเวลาในการแลกของรางวัล</v-flex>
          <v-flex xs6 class="pr-2">
            <div>ตั้งเวลาเปิด</div>
            <div>
              <v-layout row wrap class="pa-0 ma-0">
                <v-flex xs7>
                  <div class="form-control pa-1" :class="{ 'has-error': errors.has('startdate') }">
                    <DatePickerWithoutButton @input="errors.clear()" v-model="local_starttime.date">
                      <input
                        readonly
                        placeholder="DD/MM/YYYY"
                        :data-vv-as="$t('เวลาเปิด')"
                        v-validate="'required'"
                        :value="getDate(local_starttime.date)"
                        class="form-control"
                        type="text"
                        name="startdate"
                      />
                    </DatePickerWithoutButton>
                    <span class="text-error" v-if="errors.has('startdate')">{{
                      errors.first('startdate')
                    }}</span>
                  </div>
                </v-flex>
                <v-flex xs5>
                  <div class="form-control pa-1" :class="{ 'has-error': errors.has('starttime') }">
                    <CustomTimepicker @input="errors.clear()" v-model="local_starttime.time">
                      <input
                        readonly
                        placeholder="HH:mm"
                        :data-vv-as="$t('เวลาเปิด')"
                        v-validate="'required'"
                        :value="local_starttime.time"
                        class="form-control"
                        type="text"
                        name="starttime"
                      />
                    </CustomTimepicker>
                    <span class="text-error" v-if="errors.has('starttime')">{{
                      errors.first('starttime')
                    }}</span>
                  </div></v-flex
                >
              </v-layout>
            </div>
          </v-flex>
          <v-flex xs6 class="pl-2">
            <div>ตั้งเวลาปิด</div>
            <div>
              <v-layout row wrap class="pa-0 ma-0">
                <v-flex xs7>
                  <div class="form-control pa-1" :class="{ 'has-error': errors.has('enddate') }">
                    <DatePickerWithoutButton @input="errors.clear()" v-model="local_endtime.date">
                      <input
                        readonly
                        placeholder="DD/MM/YYYY"
                        :data-vv-as="$t('เวลาเปิด')"
                        v-validate="'required'"
                        :value="getDate(local_endtime.date)"
                        class="form-control"
                        type="text"
                        name="enddate"
                      />
                    </DatePickerWithoutButton>
                    <span class="text-error" v-if="errors.has('enddate')">{{
                      errors.first('enddate')
                    }}</span>
                  </div>
                </v-flex>
                <v-flex xs5>
                  <div class="form-control pa-1" :class="{ 'has-error': errors.has('endtime') }">
                    <CustomTimepicker @input="errors.clear()" v-model="local_endtime.time">
                      <input
                        readonly
                        placeholder="HH:mm"
                        :data-vv-as="$t('เวลาเปิด')"
                        v-validate="'required'"
                        :value="local_endtime.time"
                        class="form-control"
                        type="text"
                        name="endtime"
                      />
                    </CustomTimepicker>
                    <span class="text-error" v-if="errors.has('endtime')">{{
                      errors.first('endtime')
                    }}</span>
                  </div></v-flex
                >
              </v-layout>
            </div>
          </v-flex>
        </v-layout>
      </div>
    </div>
    <div class="text-xs-center pb-2">
      <v-btn @click="$emit('close')" outline color="grey">cancel</v-btn>
      <v-btn :loading="saveloading" @click="savedata" depressed color="primary">save</v-btn>
    </div>
  </div>
</template>

<script>
import api from '@/api'
import uploadfile from '@/components/elements/uploadfile.vue'
import DatePickerWithoutButton from '@/components/elements/DatePickerWithoutButton.vue'
import CustomTimepicker from '@/components/elements/CustomTimepicker.vue'
import { mapGetters } from 'vuex'
import Multiselect from 'vue-multiselect'
import moment from 'moment'

export default {
  components: {
    uploadfile,
    Multiselect,
    DatePickerWithoutButton,
    CustomTimepicker
  },
  props: ['edittype', 'editdata', 'campaignId', 'selectedCatogory', 'selectedCampaign'],
  data() {
    return {
      local_starttime: {
        date: '',
        time: ''
      },
      local_endtime: {
        date: '',
        time: ''
      },
      saveloading: false,
      input: {
        photo: '',
        name: '',
        description: '',
        category: null,
        sku: '',
        points: '',
        one_time: false, // boolean true คือแลกได้แค่ครั้งเดียว, false คือ แลกได้หลายครั้ง
        product_limit: 0, // จำนวนในการแลกของรางวัล/ 1 คน ** ถ้าแลกได้ไม่จำกัดใส่ 0 **
        effective_date: '', // YYYY-MM-DD
        end_date: '', // YYYY-MM-DD
        quantity: '',
        ecoupon_status: false,
        ecoupon_image: null,
        category_id: '',
        campaign_id: '',
        id: '',
        price: ''
      }
    }
  },
  computed: {
    ...mapGetters(['selectedBot']),
    categories() {
      return this.$store.state.toaEcouponRewardCategories
    },
    campaignName() {
      // if (this.campaignId) {
      //   let campaign = this.$store.state.toaEcouponCampaigns.find((f) => f.id == this.campaignId)
      //   return campaign.name
      // }
      return this.selectedCampaign ? this.selectedCampaign.name : ''
    }
  },
  mounted() {
    if (this.edittype == 'edit') {
      this.input = {
        ...this.editdata,
        category: this.categories.find((f) => f.id == this.editdata.category_id)
      }
    }
    this.initstartdatetime()
    this.initenddatetime()
  },
  methods: {
    getDate(val) {
      if (val) return moment(val).format('DD/MM/YYYY')
      else return ''
    },
    initstartdatetime() {
      var result = this.input.effective_date
      if (result) {
        result = moment(result).format('YYYY-MM-DD HH:mm').split(' ')
        var date = result[0]
        var time = result[1]
        this.local_starttime = { date, time }
      } else {
        this.local_starttime = { date: '', time: '' }
      }
    },
    initenddatetime() {
      var result = this.input.end_date
      if (result) {
        result = moment(result).format('YYYY-MM-DD HH:mm').split(' ')
        var date = result[0]
        var time = result[1]
        this.local_endtime = { date, time }
      } else {
        this.local_endtime = { date: '', time: '' }
      }
    },
    async savedata() {
      if (await this.$validator.validateAll()) {
        if (this.edittype == 'create') {
          this.createdata()
        } else {
          this.editrewarddata()
        }
      }
    },
    editrewarddata() {
      var start_time = this.local_starttime.date + ' ' + this.local_starttime.time
      var end_time = this.local_endtime.date + ' ' + this.local_endtime.time
      var data = {
        id: this.input.id,
        pageid: this.selectedBot.pageid,
        campaign_id: this.campaignId,
        photo: this.input.photo,
        name: this.input.name,
        description: this.input.description,
        category_id: this.input.category.id,
        category_name: this.input.category.name,
        sku: this.input.sku,
        points: this.input.points || 0,
        price: this.input.price,
        one_time: this.input.one_time || false, // boolean true คือแลกได้แค่ครั้งเดียว, false คือ แลกได้หลายครั้ง
        product_limit: this.input.onetimes ? 1 : 0, // จำนวนในการแลกของรางวัล/ 1 คน ** ถ้าแลกได้ไม่จำกัดใส่ 0 **
        effective_date: start_time, // YYYY-MM-DD
        end_date: end_time, // YYYY-MM-DD
        ecoupon_status: this.input.ecoupon_status,
        ecoupon_image: null,
        quantity: this.input.quantity
      }

      this.saveloading = true
      api.TOAECOUPONEditRewardProduct(data, (err, response) => {
        this.saveloading = false
        if (response.responsecode == 200) {
          this.$emit('onsave')
        }
      })
    },
    createdata() {
      var start_time = this.local_starttime.date + ' ' + this.local_starttime.time
      var end_time = this.local_endtime.date + ' ' + this.local_endtime.time
      var data = {
        pageid: this.selectedBot.pageid,
        campaign_id: this.campaignId,
        photo: this.input.photo,
        name: this.input.name,
        description: this.input.description,
        category_id: this.input.category.id,
        category_name: this.input.category.name,
        sku: this.input.sku,
        points: this.input.points || 0,
        price: this.input.price,
        one_time: this.input.one_time || false, // boolean true คือแลกได้แค่ครั้งเดียว, false คือ แลกได้หลายครั้ง
        product_limit: this.input.onetimes ? 1 : 0, // จำนวนในการแลกของรางวัล/ 1 คน ** ถ้าแลกได้ไม่จำกัดใส่ 0 **
        effective_date: start_time, // YYYY-MM-DD
        end_date: end_time, // YYYY-MM-DD
        ecoupon_status: this.input.ecoupon_status,
        ecoupon_image: null,
        quantity: this.input.quantity
      }
      this.saveloading = true
      api.TOAECOUPONCreateRewardProduct(data, (err, response) => {
        this.saveloading = false
        if (response.responsecode == 200) {
          this.$emit('onsave')
        }
      })
    }
  }
}
</script>

<style lang="scss" scoped></style>



// WEBPACK FOOTER //
// src/components/view/template/toaecoupon/RewardEdit.vue